var _style, _path, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgAppointmentCancel(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 24 24",
    style: {
      enableBackground: "new 0 0 24 24"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\r\n\t.st0{fill:#FBE2E2;}\r\n\t.st1{fill:#DA0B0B;}\r\n")), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M12,0L12,0c6.6,0,12,5.4,12,12l0,0c0,6.6-5.4,12-12,12l0,0C5.4,24,0,18.6,0,12l0,0C0,5.4,5.4,0,12,0z"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Layer_3"
  }, /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M12,4.8C8,4.8,4.8,8,4.8,12S8,19.2,12,19.2s7.2-3.2,7.2-7.2S16,4.8,12,4.8z M6,12c0-3.3,2.7-6,6-6 c1.5,0,2.8,0.5,3.8,1.4l-8.4,8.4C6.5,14.8,6,13.5,6,12z M12,18c-1.4,0-2.7-0.5-3.8-1.3l8.4-8.4c0.8,1,1.3,2.3,1.3,3.8 C18,15.3,15.3,18,12,18z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAppointmentCancel);
export default __webpack_public_path__ + "static/media/appointmentCancel.a046c596e69fa5d61c996badc445f30e.svg";
export { ForwardRef as ReactComponent };